module.exports = __webpack_public_path__ + "static/media/timetable coordinator.9fd24ba0.svg";